import { Skeleton } from "@/components/ui/skeleton";
import Loading from "../common/loading";
import { backofficeLinks } from "@/components/lib/SidebarLinks";

export default function PermissionSkeleton({links=backofficeLinks}) {
  return (
     <Loading links={links} >
      <div className="p-6 space-y-4 w-full">
        {/* Top filters */}
        <div className="flex flex-wrap gap-4">
          {[...Array(3)].map((_, i) => (
            <Skeleton key={i} className="h-10 w-40 rounded-md" />
          ))}
        </div>

        {/* Role Selector & Buttons */}
        <div className="flex flex-wrap justify-between items-center mt-4">
          <Skeleton className="h-10 w-44 rounded-md" />
          <div className="flex gap-4">
            <Skeleton className="h-10 w-32 rounded-md" />
            <Skeleton className="h-10 w-24 rounded-md" />
          </div>
        </div>

        {/* Tabs */}
        <div className="flex gap-2 overflow-x-auto py-2">
          {[...Array(10)].map((_, i) => (
            <Skeleton key={i} className="h-8 w-28 rounded-md" />
          ))}
        </div>

        {/* Permissions Table */}
        <div className="space-y-4">
          {[...Array(8)].map((_, i) => (
            <div key={i}>
              <Skeleton className="h-5 w-32 mb-2" />
              <div className="flex gap-4 flex-wrap">
                {[...Array(4)].map((_, j) => (
                  <Skeleton key={j} className="h-5 w-48 rounded-md" />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Footer info */}
        <div className="flex justify-between text-xs text-muted-foreground mt-10">
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-4 w-40" />
        </div>
      </div>
    </Loading>
  );
}
